// Centralized HTTP status code constants used across the app.
// Avoids magic numbers in error handling code paths.

export const HTTP_OK = 200;
export const HTTP_BAD_REQUEST = 400;
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;
export const HTTP_NOT_FOUND = 404;
export const HTTP_UNPROCESSABLE = 422;
export const HTTP_INTERNAL = 500;
